export enum ApplicationFormSchemaConfigFields {
  SSO_URL = 'sso_url',
  USERNAME = 'username',
  PASSWORD = 'password',
  OTP_SECRET = 'otp_secret',
  SSO_PROVIDER = 'sso_provider',
  SSO_USERNAME = 'sso_username',
  SSO_PASSWORD = 'sso_password',
  SSO_OTP_SECRET = 'sso_otp_secret',
  DUO_BYPASS_CODE = 'duo_bypass_code',
}
